import Promise from 'bluebird';

organizationMemberService.$inject = [
  'jsSdk.organizationMember',
  'organizationService'
];

export default function organizationMemberService(sdkOrganizationMemberService, organizationService) {
  class OrganizationMemberService {
    clear() {
      this._currentOrganizationMembers = null;
    }

    getCurrentOrganizationMembers() {
      const currentOrganization = organizationService.getCurrentOrganization();

      if (!currentOrganization) throw new Error('currentOrganization is required');

      if (this._currentOrganizationMembers) return Promise.resolve(this._currentOrganizationMembers);

      return Promise.resolve(sdkOrganizationMemberService.listByOrganizationId(currentOrganization.id))
        .tap(organizationMembers => {
          this._currentOrganizationMembers = organizationMembers;
        });
    }
  }

  return new OrganizationMemberService();
}



// WEBPACK FOOTER //
// ./src/services/organizationMemberService.js